import Api from './Api'

export default {
  getKontraktNotater (kontraktId, queryParams) {
    return Api().get('/kontrakt/' + kontraktId + '/kontraktnotat.json', {
      params: queryParams
    })
  },

  addKontraktNotat (kontraktId, data) {
    return Api().post('/kontrakt/' + kontraktId + '/kontraktnotat.json', data)
  },

  delKontraktNotat (kontraktId, notatId) {
    return Api().delete('/kontrakt/' + kontraktId + '/kontraktnotat/' + notatId + '.json')
  },

  sendKontraktNotatToAccounting (kontraktId, notatId) {
    return Api().get('/kontrakt/' + kontraktId + '/kontraktnotat/' + notatId + '/send-to-accounting.json')
  },

  getKontraktBilagOptions (kontraktId) {
    return Api().get('/kontrakt/' + kontraktId + '/bilag/options.json')
  },

  saveKontraktBilagAr (kontraktId, data) {
    return Api().post('/kontrakt/' + kontraktId + '/bilag/ar.json', data)
  },

  printLabels (kontraktId, data) {
    return Api().post('kontrakt/' + kontraktId + '/print-labels.json', data)
  },

  loadFormDropdowns () {
    return new Promise((resolve, reject) => {
      Api().get('kontrakt/dropdowns.json')
        .then((response) => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  getNotReady (queryParams) {
    return Api().get('/kontrakt/notready.json', {
      params: queryParams
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/KontraktService.js